    var Ziggy = {
        namedRoutes: [],
        baseUrl: 'https://qw.shell.ronpos.com/',
        baseProtocol: 'https',
        baseDomain: 'qw.shell.ronpos.com',
        basePort: false
    };

    export {
        Ziggy
    }
